import React, { Component } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { get, sumBy } from "lodash";
import { getMeetingCardInfoAction } from "../../actions/mom.action";
import { isValidArray } from "../../helper";
import { PATHS } from "../../constant";
import { Link } from "react-router-dom";
import {
  getLocalstorage,
  dateFormat,
  getDayOfTheGivenDate,
  getTimeOfTheGivenDate,
  getAgendaTagsColor
} from "../../helper";
import ChairedBy from "../../assets/created-by.svg";
import Meeting from "../../assets/meeting.svg";
import Calendar from "../../assets/add-decision-calendar.svg";
import Venue from "../../assets/venue.svg";

class AgendaCardInfo extends Component {
  state = {
    isLoading: true,
    cardInfo: null
  };

  async componentDidMount() {
    const response = await this.getCardInfo();
    const { data } = response || {};
    this.setState({
      isLoading: false,
      cardInfo: get(data, "data")
    });
  }

  getCardInfo = () => {
    const { agendaDetails } = this.props;
    return getMeetingCardInfoAction(
      undefined,
      agendaDetails && agendaDetails.id
    );
  };

  render() {
    const { onClose, agendaDetails } = this.props;
    const { cardInfo } = this.state;
    const prgatiProject = [];
    const nonPragatiProject = [];
    const pendingWithRmRs = [];

    get(cardInfo, "pragati") &&
      get(cardInfo, "pragati").forEach(element => {
        const isProjectExists = prgatiProject.find(pragati => {
          return element.sector === pragati.sector;
        });
        !isProjectExists && prgatiProject.push(element);
      });

    get(cardInfo, "nonPragati") &&
      get(cardInfo, "nonPragati").forEach(element => {
        const isProjectExists = nonPragatiProject.find(proj => {
          return element.sector === proj.sector;
        });
        !isProjectExists && nonPragatiProject.push(element);
      });

    get(cardInfo, "pendingWithRMRS") &&
      get(cardInfo, "pendingWithRMRS").forEach(element => {
        const isProjectExists = pendingWithRmRs.find(proj => {
          return element.issueId === proj.issueId;
        });
        !isProjectExists && pendingWithRmRs.push(element);
      });

    return (
      <Modal
        class="agenda-card-info-modal"
        show={true}
        onHide={onClose}
        animation={true}
        size="lg"
      >
        <section className="agenda-card-info-title">
          <Modal.Header closeButton>
            <Modal.Title>Agenda Summary</Modal.Title>
          </Modal.Header>
        </section>
        <section className="card-info-body">
          <section className="card-info-header">
            <div className="agenda-list-title">
              AGENDA ID{" "}
              <span className="agenda-id">
                <Link
                  to={{
                    pathname: PATHS.AGENDA_DETAILS,
                    search: `?agendaId=${get(agendaDetails, "id", "NA")}`,
                    state: {
                      agendaId: agendaDetails.id
                    }
                  }}
                >
                  #{agendaDetails && agendaDetails.id}
                </Link>
              </span>{" "}
              {get(cardInfo, "totalProjectCount") ? (
                <span className="agenda-total">
                  | {get(cardInfo, "totalProjectCount")} Project(s){" "}
                </span>
              ) : null}
              |{" "}
              <span className="agenda-total">
                {get(cardInfo, "totalIssueCount")} Issue(s)
              </span>
              {get(cardInfo, "totalProjectCost") ? (
                <span className="agenda-total">
                  {" "}
                  | &#x20B9; {get(cardInfo, "totalProjectCost").toFixed(2)} Cr.
                </span>
              ) : null}
              <h3 className="agenda-name-in-cards">
                {agendaDetails && agendaDetails.agendaName}
              </h3>
            </div>
            <div className="agenda-card">
              <div
                className={`${getAgendaTagsColor(
                  agendaDetails.meetingStatus
                )} ${
                  agendaDetails.meetingStatus === "DRAFT"
                    ? "draft-agenda-btn"
                    : ""
                } agenda-stage`}
              >
                <div
                  className={`agenda-stage-background ${
                    agendaDetails.meetingStatus === "DRAFT"
                      ? "draft-agenda-text"
                      : ""
                  }`}
                >
                  {agendaDetails.meetingStatus}
                </div>
              </div>
            </div>
          </section>
          <div className="flex-style">
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={Calendar} />
              </span>
              <div>
                <span>
                  <b>When</b>
                  <br />
                  {getDayOfTheGivenDate(agendaDetails.meetingDate) +
                    ", " +
                    dateFormat(get(agendaDetails, "meetingDate")) +
                    (agendaDetails.meetingTimeFrom !== null &&
                    agendaDetails.meetingTimeFrom !== 0
                      ? ", " +
                        getTimeOfTheGivenDate(agendaDetails.meetingTimeFrom)
                      : "")}
                </span>
              </div>
            </div>
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={Venue} />
              </span>
              <div>
                <span>
                  <b>Venue</b>
                  <br />
                  {agendaDetails && agendaDetails.venueName}
                </span>
              </div>
            </div>
          </div>
          <div className="flex-style">
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={Meeting} />
              </span>
              <div>
                <span>
                  <b>Meeting Type</b>
                  <br />
                  {agendaDetails && agendaDetails.meetingType
                    ? agendaDetails && agendaDetails.meetingType
                    : "NA"}
                </span>
              </div>
            </div>
            <div className="flex-width d-flex agenda-card-chairedby">
              <span>
                <Image src={ChairedBy} />
              </span>
              <div>
                <span>
                  <b>Chaired by</b>
                  <br />
                  {agendaDetails && agendaDetails.meetingChairedBy
                    ? agendaDetails && agendaDetails.meetingChairedBy
                    : null}
                </span>
              </div>
            </div>
          </div>

          <div>
            {prgatiProject && prgatiProject.length ? (
              <div className="meeting-project-info">
                <b className="">Pragati</b>
                <div className="sector-detail-box">
                  {prgatiProject && prgatiProject.length} SECTOR(S) |{" "}
                  {sumBy(prgatiProject, "projectCount")} PROJECT(S) | &#x20B9;{" "}
                  {sumBy(prgatiProject, "issueCount")} ISSUE(S) |{" "}
                  {sumBy(prgatiProject, "projectCost").toFixed(2)} Crores
                </div>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Sector Name</th>
                      <th>No. of Project(s)</th>
                      <th>No. of Issue(s)</th>
                      <th>Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prgatiProject.map((project, index) => {
                      return (
                        <tr>
                          <td>{project.sector}</td>
                          <td>{project.projectCount}</td>
                          <td>{project.issueCount}</td>
                          <td>&#x20B9; {project.projectCost.toFixed(2)} Cr.</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
          <div>
            {nonPragatiProject && nonPragatiProject.length ? (
              <div className="meeting-project-info">
                <b className="">Non-Pragati</b>
                <div className="sector-detail-box">
                  {nonPragatiProject && nonPragatiProject.length} SECTOR(S) |{" "}
                  {sumBy(nonPragatiProject, "projectCount")} PROJECT(S) |{" "}
                  &#x20B9;
                  {sumBy(nonPragatiProject, "issueCount")} ISSUE(S) |{" "}
                  {sumBy(nonPragatiProject, "projectCost").toFixed(2)} Crores
                </div>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Sector Name</th>
                      <th>No. of Project(s)</th>
                      <th>No. of Issue(s)</th>

                      <th>Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nonPragatiProject.map((project, index) => {
                      return (
                        <tr>
                          <td>{project.sector}</td>
                          <td>{project.projectCount}</td>
                          <td>{project.issueCount}</td>
                          <td>&#x20B9; {project.projectCost.toFixed(2)} Cr.</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : null}
          </div>
          {isValidArray(get(cardInfo, "issueResolved")) ? (
            <div className="agenda-issues-info meeting-project-info">
              <span>
                <b className="">
                  Issues Resolved ({get(cardInfo, "issueResolved").length})
                </b>
                <p className="agenda-projects-list">
                  {get(cardInfo, "issueResolved").map((issue, index) => {
                    return (
                      <Link
                        to={{
                          pathname: PATHS.ISSUE_DETAIL,
                          search: `projectId=${issue.projectId}&issueId=${
                            issue.issueId
                          }`
                        }}
                      >
                        {" "}
                        #{issue.issueId}
                        {index < get(cardInfo, "issueResolved").length - 1
                          ? ","
                          : ""}
                      </Link>
                    );
                  })}
                </p>
              </span>
            </div>
          ) : null}

          {isValidArray(get(cardInfo, "projectClosed")) ? (
            <div className="meeting-pragati-project-info">
              <b className="">Projects Closed</b>
              <div className="agenda-projects-list">
                <b>
                  <span>
                    {get(cardInfo, "projectClosed").length} Project(s)
                  </span>{" "}
                  |{" "}
                  <span>
                    &#8377; {get(cardInfo, "closedProjectsCost").toFixed(2)} Cr.
                  </span>
                </b>
                <br />
                <span>
                  Project(s) :
                  {get(cardInfo, "projectClosed").map((project, index) => {
                    return (
                      <Link
                        to={{
                          pathname: PATHS.PROJECT_DETAILS,
                          search: `projectId=${project}`
                        }}
                      >
                        {" "}
                        #{project}
                        {index < get(cardInfo, "projectClosed").length - 1
                          ? ","
                          : ""}
                      </Link>
                    );
                  })}
                </span>
              </div>
            </div>
          ) : null}

          {isValidArray(get(cardInfo, "pendingWithRMRS")) ? (
            <div className="meeting-pragati-project-info">
              <span>
                <b className="">
                  RM/RS Pending Issues (
                  {pendingWithRmRs && pendingWithRmRs.length})
                </b>
                <p className="sector-box">
                  {pendingWithRmRs &&
                    pendingWithRmRs.length &&
                    pendingWithRmRs.map((project, index) => {
                      return (
                        <Link
                          to={{
                            pathname: PATHS.ISSUE_DETAIL,
                            search: `projectId=${project.projectId}&issueId=${
                              project.issueId
                            }`
                          }}
                        >
                          #{project.issueId}
                          {index < pendingWithRmRs.length - 1 ? ", " : ""}
                        </Link>
                      );
                    })}
                </p>
              </span>
            </div>
          ) : null}

          <div className="agenda-created-on">
            Created By <span>{agendaDetails.meetingCreatedBy} on </span>
            <span>
              {" "}
              {getDayOfTheGivenDate(agendaDetails.agendaCreatedOn) +
                ", " +
                dateFormat(agendaDetails.agendaCreatedOn) +
                ", " +
                getTimeOfTheGivenDate(agendaDetails.agendaCreatedOn)}
            </span>
          </div>
        </section>
      </Modal>
    );
  }
}

export { AgendaCardInfo };
